<div style="display: flex;align-items: center;justify-content: space-between">
  <div style="display:flex;justify-content: flex-start">
    <h2 mat-dialog-title >
      <span class="primary">{{"FORGET.RECOVER_PASSWORD" | translate}}</span>
    </h2>
  </div>
  <div style="display:flex;justify-content: flex-end">
    <button matDialogClose mat-icon-button color="warn">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div style="position: relative" class="forgetPass-container">
  <div class="text-container">
    <p class="primary f-w-400 f-s-14">{{'LOGIN.TYPE_TO_RESET' | translate}}</p>
  </div>
</div>

<mat-dialog-content class="mat-typography" style="width: 600px;">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="row">
    <p class="email-label primary">{{ "FORGET.EMAIL" | translate }}</p>

    <mat-form-field style="margin: 10px 0;" class="col-sm-12 col-md-12" appearance="outline">
      <mat-label>{{ "FORGET.EMAIL" | translate }}</mat-label>
      <input matInput formControlName="email"/>
    </mat-form-field>
  </form>
</mat-dialog-content>


<mat-dialog-actions class="p-24 p-t-0">

  <button class="col-sm-5 m-b-6" mat-raised-button  mat-dialog-close>
    {{ "COMMON.CANCEL" | translate }}
  </button>

  <button class="col-sm-5 m-b-6"
          mat-flat-button
          [disabled]="!form.valid"
          (click)="onSubmit()"
          color="primary">
    {{ "FORGET.SEND_RESET_LINK" | translate }}
  </button>

</mat-dialog-actions>

